var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useRef, useState } from 'react';
export var useIsOverflow = function () {
    var _a = __read(useState(false), 2), isOverflow = _a[0], setIsOverflow = _a[1];
    var overflowRef = useRef(null);
    useEffect(function () {
        if (!overflowRef || !overflowRef.current) {
            return;
        }
        setIsOverflow(overflowRef.current.clientWidth < overflowRef.current.scrollWidth);
    }, [overflowRef]);
    return { overflowRef: overflowRef, isOverflow: isOverflow };
};
